<template>
	<div class="page">
		<div class="screenLine">
			<el-input v-model="keyword" placeholder="请输入关键字" style="width:140px;margin-right: 16px;" @keyup.enter.native="changeSearch"></el-input>
			<el-select class="titleSelect" v-model="type" @change="changeSearch" placeholder="请选择业务分类" style="width:120px">
				<el-option
				v-for="item in [{value:0,label:'全部分类'},{value:2,label:'洗美'}, {value:6,label:'寄养'}, {value:5,label:'医疗服务'}, {value:8,label:'活体'}, {value:3,label:'病例'}]"
				:key="item.value"
				:label="item.label"
				:value="item.value">
				</el-option>
			</el-select>
			<el-date-picker v-model="datetimerange" @change="changeSearch" type="datetimerange" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" style="margin-right:16px">
			</el-date-picker>
			<el-button type="primary" plain @click="reset">重置</el-button>
			<el-button  @click="down">下载</el-button>
			<el-button  @click="clickUploadTemplate">上传模板</el-button>
		</div>
		<div class="tableBox">
			<el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="55">
				</el-table-column>
				<el-table-column label="业务类型" prop="id">
					<template slot-scope="props">
						<span v-if="props.row.contractType===2">洗美</span>
						<span v-if="props.row.contractType===6">寄养</span>
						<span v-if="props.row.contractType===5">医疗服务</span>
						<span v-if="props.row.contractType===8">活体</span>
						<span v-if="props.row.contractType===3">病例</span>
					</template>
				</el-table-column>
				<el-table-column label="创建时间" prop="medicalServiceName">
					<template slot-scope="props">
						<div>{{$public.FTime(props.row.createTime,'YYYY-MM-DD HH:mm:ss')}}</div>
					</template>
				</el-table-column>
				<el-table-column label="创建人" prop="createUserName">
				</el-table-column>
				<el-table-column label="签署份数" prop="signCount">
				</el-table-column>
				<el-table-column label="是否使用印章" prop="petName">
					<template slot-scope="props">
						<div v-if="$public.isNull(props.row.sealId)">否</div>
						<div v-else>{{props.row.sealName}}</div>
					</template>
				</el-table-column>
				<el-table-column label="模板状态" prop="petName">
					<template slot-scope="props">
						<div v-if="props.row.state===1">已启用</div>
						<div v-if="props.row.state===2">已停用</div>
					</template>
				</el-table-column>
				<el-table-column label="操作" >
					<template slot-scope="props">
						<el-button type="text" size="mini" @click="see(props.row)">查看</el-button>
						<el-button v-if="props.row.state===1" type="text" size="mini" @click="changeTemplateState(props.row)">停用</el-button>
						<el-button v-if="props.row.state===2" type="text" size="mini" @click="changeTemplateState(props.row)">启用</el-button>
						<el-button v-if="props.row.state===2" type="text" size="mini" @click="deleteTemplateState(props.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="pagePosi">
			<page style="padding:10px 0;" :page="page.page" :total="page.total" :pageSize="page.pageSize" @change="changePage"></page>
		</div>
		<div v-if="dialogUploadTemplate_state">
			<uploadTemplate @submit="submit_uploadTemplate"></uploadTemplate>
		</div>
		<!-- <div v-if="pdfUrl.length>0">
			<pdf :src="pdfUrl"></pdf>
		</div> -->
	</div>
</template>
<script>
	import page from "../../../components/page.vue"
	import uploadTemplate from "./comp_uploadTemplate.vue"
	// import pdf from "vue-pdf"
	export default {
		components:{page,uploadTemplate},
		data(){
			return{
				// 上传
				dialogUploadTemplate_state:false,
				
				keyword:'',
				containStop:true,  // 是否包含已停用
				desc:true,  // 排序
				type:0,
				datetimerange:[],  // 创建时间
				
				tableData:[],
				page:{
					page:1,
					pageSize:10,
					total:0
				},
				// 下载 
				downList:[],
				// 查看
				// pdfUrl:'',
			}
		},
		computed:{
		},
		mounted(){
			this.getTableData();
		},
		methods: {
			// 查看
			see(row){
				let loading = this.$loading();
				this.$http.get(process.env.VUE_APP_business+'/api/Contract/Detail', {id:row.id}).then(res => {
					loading.close()
					if (res.code == 0) {
						// this.pdfUrl = res.data.contractPdfUrl;
						window.open(res.data.contractPdfUrl)
					}
				})
			},
			reset(){
				this.keyword = ''
				this.type = 0
				this.datetimerange = []
				this.page.page = 1;
				this.getTableData();
			},
			changeSearch(){
				this.page.page = 1;
				this.getTableData();
			},
			// 改变分页
			changePage(num){
				this.page.page = num;
				this.getTableData();
			},
			getTableData(){
				let params = {
					"contractType": this.type===0?[]:[this.type],  // 合同类型
					"sealType": 0,  // 印章类型
					"beginTime": "",  // 开始时间
					"endTime": "",  // 结束时间
					"desc":this.desc,
					"containStop": this.containStop,  // 是否包含停用合同
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
					"keyword": this.keyword,
				}
				if(this.datetimerange&&this.datetimerange.length===2){
					params.beginTime=(''+new Date(this.datetimerange[0]).getTime()).substr(0,10);
					params.endTime=(''+new Date(this.datetimerange[1]).getTime()).substr(0,10);
				}
				let loading=this.$loading();
				this.$http.post(process.env.VUE_APP_business+'/api/Contract/List', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.page.total = res.data.count;
					}
				})
			},
			// 修改启停状态
			changeTemplateState(row){
				this.$confirm('确定要'+(row.state===1?'停用':'启用')+'该模板吗?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.get(process.env.VUE_APP_business+'/api/Contract/Update', {id:row.id}).then(res => {
						if (res.code == 0) {
							this.$message({
								message: '操作成功',
								type: 'success'
							});
							this.getTableData();
						}
					})
				})
			},
			// 删除
			deleteTemplateState(row){
				this.$confirm('确定要删除该模板吗?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.get(process.env.VUE_APP_business+'/api/Contract/Delete', {id:row.id}).then(res => {
						if (res.code == 0) {
							this.$message({
								message: '操作成功',
								type: 'success'
							});
							this.getTableData();
						}
					})
				})
			},
			// 下载
			handleSelectionChange(val) {
				this.downList = val;
			},
			down(){
				if(this.downList.length===0){
					this.$message({
						message: '请选择要下载的文件',
						type: 'error'
					});
					return ;
				}
				for(let i=0;i<this.downList.length;i++){
					const iframe = document.createElement("iframe");
					iframe.style.display = "none"; 
					iframe.style.height = 0; 
					iframe.src = this.downList[i].contractUrl;
					document.body.appendChild(iframe);
					setTimeout(()=>{
						iframe.remove();
					},100000);
				}
			},
			// 上传模板
			clickUploadTemplate(){
				this.dialogUploadTemplate_state = true;
			},
			submit_uploadTemplate(obj){
				this.dialogUploadTemplate_state = false;
				if(obj.type==='success'){
					this.getTableData()
				}
			},
		}
	}
</script>
<style scoped lang="scss">
	.page {
		padding: 16px 16px 65px 16px;
		height: 100%;
		box-sizing: border-box;
		position: relative;

		.screenLine {
			display: flex;
			.screenLineR{
				flex: 1;
				display: flex;
				justify-content: flex-end;
				.tabView{
					display: flex;
					align-items: center;
					width: 278px;
					height: 44px;
					background: #E7E7F4;
					border-radius: 10px;
					justify-content: space-around;
					.tabItem{
						width: 90px;
						height: 36px;
						font-size: 14px;
						text-align: center;
						line-height: 36px;
						border-radius: 8px;
					}
					.tabActiveItem{
						width: 90px;
						height: 36px;
						font-size: 14px;
						text-align: center;
						line-height: 36px;
						border-radius: 8px;
						background: #3A6DFF;
						color: #fff;
					}
				}
			}
			.titleSelect{
				width: 130px;
				margin-right: 16px;
			}
		}

		.tableBox {
			padding: 16px;
			border-radius: 8px;
			background-color: #fff;
			box-sizing: border-box;
			margin-top: 16px;
			height: calc(100% - 56px);
		}

		.pagePosi {
			position: absolute;
			bottom: 0;
			left: 16px;
			right: 16px;
			text-align: right;
			background-color: #fff;
			padding: 0 10px;
			border-radius: 8px 8px 0 0;
		}
	}
</style>
